import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'circle-caret-right',
  'IconCircleCaretRight',
  [
    ['path', { d: 'M15 12l-4 -4v8z', key: 'svg-0' }],
    ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-1' }],
  ],
);
